import React, { createContext, useContext, useState, useRef, useCallback } from "react";
import Loader from "../components/common/Loader";

const TxContext = createContext(null);

// Wraps an async transaction with a full-screen loader + status text.
// Usage: const { run } = useTx(); await run("Activating package", async () => {...})
export function TxProvider({ children }) {
  const [busy, setBusy] = useState(false);
  const [label, setLabel] = useState("Processing");
  const depth = useRef(0);

  const run = useCallback(async (text, fn) => {
    depth.current += 1;
    setLabel(text || "Processing");
    setBusy(true);
    try {
      return await fn();
    } finally {
      depth.current -= 1;
      if (depth.current <= 0) {
        depth.current = 0;
        setBusy(false);
      }
    }
  }, []);

  return (
    <TxContext.Provider value={{ run, busy }}>
      {children}
      {busy && <Loader text={label} />}
    </TxContext.Provider>
  );
}

export function useTx() {
  const ctx = useContext(TxContext);
  if (!ctx) throw new Error("useTx must be used within TxProvider");
  return ctx;
}
